/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const REFRESH_INVOICE_REGISTER_DISPLAY =
  'REFRESH_INVOICE_REGISTER_DISPLAY';
export const SET_SELECTED_INPUT_INSTITUTIONAL_CLAIMS_DISCREPANCY =
  'SET_SELECTED_INPUT_INSTITUTIONAL_CLAIMS_DISCREPANCY';
export const IS_LOADING_INSTITUTIONAL_CLAIMS_DISCREPANCY =
  'IS_LOADING_INSTITUTIONAL_CLAIMS_DISCREPANCY';
export const GET_MAX_QUARTER_INVOICE_REGISTER =
  'GET_MAX_QUARTER_INVOICE_REGISTER';
//api
export const GET_INVOICE_RESULT = 'GET_INVOICE_RESULT';
export const REFRESH_INVOICE_REGISTER = 'REFRESH_INVOICE_REGISTER';
export const GET_INVOICE_RESULT_UNCHECKED = 'GET_INVOICE_RESULT_UNCHECKED';
export const NO_DATA_MESSAGE = 'NO_DATA_MESSAGE';
